import React from 'react';

class TextArea extends React.Component{

    render(){
      const { 
        input_type, 
        input_name, 
        input_label, 
        input_value, 
        input_placeholder, 
        input_invalid_feedback,
        input_helper,
        input_rows, 
        input_id, 
        input_onChange 
      } = this.props;
      
      return(
        <div className="form-group">
          <label className="form-control-label">{ this.props.input_label }</label>
          <textarea 
            className="form-control" 
            type={ input_type } 
            name={ input_name } 
            value={ input_value } 
            onChange={ input_onChange } 
            placeholder={ input_placeholder } 
            rows={ input_rows }
            id={ input_id }>
          </textarea>
          {input_helper && <small className="help-block">{input_helper}</small>}
          <div className="invalid-feedback">{ input_invalid_feedback }</div>
        </div>
      );
    }
} 

export { TextArea };


// WEBPACK FOOTER //
// ./src/components/TextArea.js